<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .buttons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: utils.in_rem(12px);
  }
</style>

<script>
  import { capitalize } from "../../../../../assets/js/src/general/utils";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import DemoActionButton from "../../../elements/Marketing/BookDemo/DemoActionButton.svelte";
  import BookDemoButton from "../../Explore/components/BookDemoButton.svelte";
  import { getMarketingPageContext } from "../context.svelte";

  let { tourLink = "", webpageLink = "", license } = $props();
  const ctx = getMarketingPageContext();

  let title = $derived(capitalize((tourLink && ctx.page?.slice(1)) || ""));

  let navatticDetails = $derived({
    "data-navattic-open": tourLink,
    "data-navattic-title": `${title ? title + " - " : ""}Walkthrough`,
  });

  export const onclick = () => window.NavatticEmbed.openPopup(tourLink);

  const onWebpageClick = () => {
    window.location.href = webpageLink;
  };
</script>

<div class="buttons">
  {#if tourLink}
    <Button size="large" kind="tertiary" {onclick} {...navatticDetails}
      >Take a tour</Button
    >
  {/if}
  {#if webpageLink}
    <Button size="large" kind="tertiary" onclick={onWebpageClick}
      >Take a tour</Button
    >
    <DemoActionButton {license} />
  {:else}
    <BookDemoButton kind="upgrade" />
  {/if}
</div>
